<template>
  <div style="height: calc(100vh - 132px)" v-bar>
    <div>
      <v-row no-gutters>
        <v-col>
          <v-list>
            <template v-for="user in sortedUsers">
              <v-list-item :key="user.id">
                <v-list-item-icon class="mr-5">
                  <user-avatar
                    avatar-size="30"
                    icon-size="25"
                    :user-id="user.id"
                    :url="user.image_path || null"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ user.email }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="openUserEditDialog(user)">
                    <v-icon color="grey lighten-1">mdi-settings-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </div>
    <UserEditDialog
      ref="userEditDialog"
      :dialog.sync="isEditUserDialogVisible"
      :user="currentEditUser"
      @cancel="closeUserEditDialog"
    />
  </div>
</template>
<script>
import UserAvatar from '@/components/settings/UserAvatar';
import UserEditDialog from '@/components/settings/UserEditDialog';
export default {
  components: {
    UserAvatar,
    UserEditDialog
  },
  props: {
    users: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: () => ({
    currentEditUser: {},
    isEditUserDialogVisible: false
  }),
  computed: {
    sortedUsers() {
      return JSON.parse(JSON.stringify(this.users)).sort((a, b) => {
        return a.email > b.email ? 1 : -1;
      });
    }
  },
  methods: {
    closeUserEditDialog() {
      this.currentEditUser = {};
      this.isEditUserDialogVisible = false;
    },
    openUserEditDialog(user) {
      this.currentEditUser = JSON.parse(JSON.stringify(user));
      this.$refs.userEditDialog.$refs.form.resetValidation();
      this.isEditUserDialogVisible = true;
    }
  }
};
</script>
